import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import SubmitLockButton from 'components/submit-lock-button/submit-lock-button.component'

type CancelSubscriptionDialogProps = {
  open: boolean
  nextBillingDate?: string | null
  submitting?: boolean
  errorMessage?: string | null
  onClose: () => void
  onConfirm: () => void
}

const CancelSubscriptionDialog = ({
  open,
  nextBillingDate,
  submitting = false,
  errorMessage,
  onClose,
  onConfirm,
}: CancelSubscriptionDialogProps) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogContent sx={{ p: 0 }}>
      <Box sx={{ px: 3, pt: 3, pb: 2, position: 'relative' }}>
        <IconButton
          aria-label="Close"
          onClick={onClose}
          sx={{ position: 'absolute', top: 12, right: 12 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h5" fontWeight={700} color="#12355b" pr={5}>
          Cancel Subscription?
        </Typography>
        <Typography mt={1} color="#6b7280">
          Are you sure you want to cancel your subscription?
        </Typography>
        <Box
          sx={{
            mt: 2.5,
            display: 'flex',
            gap: 1.5,
            bgcolor: '#fdecec',
            borderRadius: '12px',
            p: 2,
          }}
        >
          <InfoOutlinedIcon sx={{ color: '#dc2626', mt: '2px' }} />
          <Box>
            <Typography fontWeight={700} color="#991b1b" fontSize={14}>
              {nextBillingDate
                ? `Your subscription will remain active until ${nextBillingDate}.`
                : 'Your subscription will remain active until the end of your current billing period.'}
            </Typography>
            <Typography color="#4b5563" fontSize={13} mt={0.5}>
              You will not be charged from the next billing cycle.
            </Typography>
          </Box>
        </Box>
        {errorMessage && (
          <Typography color="error" fontSize={14} mt={2}>
            {errorMessage}
          </Typography>
        )}
      </Box>
      <Divider />
      <Stack direction="row" spacing={1.5} justifyContent="flex-end" sx={{ px: 3, py: 2 }}>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onClose}
          sx={{ px: 2.5, py: 1, textTransform: 'none', borderColor: '#d1d5db' }}
        >
          Keep Subscription
        </Button>
        <SubmitLockButton
          variant="contained"
          color="error"
          disabled={submitting}
          onClick={onConfirm}
          sx={{ px: 2.5, py: 1, textTransform: 'none', fontWeight: 700 }}
        >
          {submitting ? 'Cancelling...' : 'Cancel Subscription'}
        </SubmitLockButton>
      </Stack>
    </DialogContent>
  </Dialog>
)

export default CancelSubscriptionDialog
